module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cYaps5/tc-custom/9781667444659.jpg?1682168952506",
      "alt": "This image is the cover for the book Estou farta! Mamãe vai ao Caribe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Estou farta! Mamãe vai ao Caribe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A mamãe está farta!"), _c('br'), _vm._v(" É isso aí!"), _c('br'), _vm._v(" Ela passa sua vida lavando, cozinhando, passando a ferro e cuidando de todos."), _c('br'), _vm._v(" Ela não aguenta mais, ela precisa tanto de férias, então ela vai ao Caribe!"), _c('br'), _vm._v(" Matias, de oito anos, seu irmão Antônio e seu pai ficarão por conta própria durante uma semana."), _c('br'), _vm._v(" Descubra suas aventuras!"), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.P. Hernández, Angela Gaia Vampre\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Antonio Pérez Hernández é professor do Ensino Fundamental (especialista em Educação Musical, Audição e Linguagem e Pedagogia Terapêutica), pedagogo, Mestre em Pesquisa e Inovação em Educação e Doutor, menção cum laude, pela sua Tese de Doutorado Avaliação da competência em comunicação linguística por meio de histórias no Ensino Fundamental."), _c('br'), _vm._v(" Ele foi premiado com um segundo prêmio no Prêmio de Criação Literária Nemira e um resultado finalista no Concurso Internacional de Romance de Fantasia e Terror de Dagón."), _c('br'), _vm._v(" Publicou mais de quarenta livros, traduzidos em sete idiomas: grego, alemão, português, italiano, inglês, francês e holandês."), _c('br'), _vm._v(" Atualmente combina seu trabalho docente com a escrita."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0